import React from "react";

export default function LoadingIndicator() {
    return <>
        <div className="sb-suggestions--loading">
            <span className="sb-suggestions--dot"></span>
            <span className="sb-suggestions--dot"></span>
            <span className="sb-suggestions--dot"></span>
        </div>
    </>
}